import React from 'react';
import Card from "@mui/material/Card"
import CardContent from "@mui/material/CardContent"
import './BeneficiosClientesSection.css'

export function BeneficiosClientesSection() {
    return (
        <section className="benefits-section-client">
            <div className="section-container-client">
                <h2 className="section-title-client">
                    Por que usar o Clube do Banho?
                </h2>

                <div className="benefits-grid-client">
                    <Card className="benefit-card-client">
                        <CardContent className="benefit-card-content-client">
                            <div className="benefit-icon-circle-client">
                                <span className="material-icon">attach_money</span>
                            </div>
                            <h3 className="benefit-title-client">Preco previsivel</h3>
                            <p className="benefit-text-client">
                                Sem sustos no fim do mes. Voce sabe exatamente quanto vai pagar antes de agendar.
                            </p>
                        </CardContent>
                    </Card>

                    <Card className="benefit-card-client">
                        <CardContent className="benefit-card-content-client">
                            <div className="benefit-icon-circle-client">
                                <span className="material-icon">calendar_today</span>
                            </div>
                            <h3 className="benefit-title-client">Agendamento facil</h3>
                            <p className="benefit-text-client">
                                Escolha o melhor horario no app e pronto. Simples, rapido e sem complicacao.
                            </p>
                        </CardContent>
                    </Card>

                    <Card className="benefit-card-client">
                        <CardContent className="benefit-card-content-client">
                            <div className="benefit-icon-circle-client">
                                <span className="material-icon">verified_user</span>
                            </div>
                            <h3 className="benefit-title-client">Rede verificada</h3>
                            <p className="benefit-text-client">
                                Qualidade e carinho garantidos. Todos os parceiros sao avaliados pelos tutores.
                            </p>
                        </CardContent>
                    </Card>
                </div>
            </div>
        </section>
    )
}

